import { render } from "./daNianPayModel.vue?vue&type=template&id=0d08f0d8"
import script from "./daNianPayModel.vue?vue&type=script&lang=js"
export * from "./daNianPayModel.vue?vue&type=script&lang=js"

import "./daNianPayModel.vue?vue&type=style&index=0&id=0d08f0d8&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__